<template>
  <div class="heading">
    <div class="flex justify-between items-center truncate lg:pb-4">
      <slot name="title">
        <component
          :is="`h${level}`"
          class="heading__title mr-2 truncate"
          :class="level > 1 && `h${level}`"
        >
          {{ headingTitle }}
        </component>
      </slot>
      <CloseButton
        v-if="hasIconClose"
        @click="$emit('clickCloseIcon')"
      />
    </div>
    <slot name="description">
      <div
        v-if="description"
        class="heading__description"
      >
        {{ description }}
      </div>
    </slot>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'ModalHeading',

  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    level: {
      type: Number,
      default: 2,
    },
    hasIconClose: {
      type: Boolean,
      default: true,
    },
    titleInCapitals: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['clickCloseIcon'],
  setup(props: {title: string, titleInCapitals: boolean}) {

    const headingTitle = computed(() => props.titleInCapitals ? props.title.toUpperCase() : props.title);

    return {
      headingTitle,
    };
  
  },
});

</script>
